import React, { ReactNode, useContext, useEffect, useState } from 'react';

import ControlSystemKeysContext from '@totem/components/controlSystemDetail/keys/ControlSystemKeysContext';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { ForeignKey } from '@totem/types/common';
import { CONTROL_SYSTEMS_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  controlSystemId: string;
  children?: ReactNode;
};

const ControlSystemKeysContainer = ({ controlSystemId, children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<ForeignKey[]>([]);
  const [refresh, setRefresh] = useState<boolean>(true);

  useEffect(() => {
    setRefresh(true);
  }, [controlSystemId]);

  useEffect(() => {
    if (!refresh) {
      return;
    }

    setRefresh(false);

    setLoading(true);

    fetch(`${CONTROL_SYSTEMS_ENDPOINT}/${controlSystemId}/keys`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: ForeignKey[]) => {
        setData(Array.isArray(result) ? result : []);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [refresh, controlSystemId, getApiToken]);

  return (
    <ControlSystemKeysContext.Provider
      value={{
        loading,
        data,
        controlSystemId,
        requestRefresh: () => setRefresh(true),
      }}
    >
      {children}
    </ControlSystemKeysContext.Provider>
  );
};

export default ControlSystemKeysContainer;
